import React, { useState, useEffect } from 'react'

const CHATBOT_BOTTOM_PADRAO = 50
const CHATBOT_ESPACO_ACIMA_RODAPE = 16

export function Chatbot() {
  const [isOpen, setIsOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [bottomOffset, setBottomOffset] = useState(CHATBOT_BOTTOM_PADRAO)

  // Detecta tamanho da tela
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Mantém o botão fixo acima do rodapé quando ele entra na tela
  useEffect(() => {
    let frameId = 0

    const atualizarPosicao = () => {
      const footer = document.querySelector('footer')
      if (!footer) {
        setBottomOffset(CHATBOT_BOTTOM_PADRAO)
        return
      }

      const footerTop = footer.getBoundingClientRect().top
      const overlap = Math.max(0, window.innerHeight - footerTop)
      const novoBottom = Math.max(
        CHATBOT_BOTTOM_PADRAO,
        overlap + CHATBOT_ESPACO_ACIMA_RODAPE
      )

      setBottomOffset(novoBottom)
    }

    const agendarAtualizacao = () => {
      cancelAnimationFrame(frameId)
      frameId = requestAnimationFrame(atualizarPosicao)
    }

    atualizarPosicao()
    window.addEventListener('scroll', agendarAtualizacao, { passive: true })
    window.addEventListener('resize', agendarAtualizacao)

    return () => {
      cancelAnimationFrame(frameId)
      window.removeEventListener('scroll', agendarAtualizacao)
      window.removeEventListener('resize', agendarAtualizacao)
    }
  }, [])

  // Função para abrir o chatbot com loading
  const handleOpenChatbot = () => {
    setIsLoading(true)
    setIsOpen(true)
    
    // Simula um pequeno delay para mostrar o loading
    setTimeout(() => {
      setIsLoading(false)
    }, 500)
  }

  return (
    <>
      {/* Botão flutuante do chatbot */}
      {!isOpen && (
        <div
          className="chatbot-button"
          style={{
            position: 'fixed',
            bottom: `${bottomOffset}px`,
            right: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            zIndex: 9998, // Z-index alto para ficar acima da NavBar
            transition: 'bottom 0.15s ease-out',
          }}
        >
          {/* Balão de fala */}
          <div
            style={{
              backgroundColor: 'white',
              padding: '12px 12px',
              borderRadius: '18px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              maxWidth: '200px',
              fontSize: '0.9rem',
              color: '#333',
              fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
              lineHeight: 1.4,
              position: 'relative'
            }}
          >
            Olá, como posso te ajudar?
            {/* Seta do balão */}
            <div
              style={{
                position: 'absolute',
                right: '-8px',
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: '#D5E1E6',
                width: '0',
                height: '0',
                borderLeft: '8px solid white',
                borderTop: '8px solid transparent',
                borderBottom: '8px solid transparent'
              }}
            />
          </div>

          {/* Botão da Zula */}
          <div
            onClick={handleOpenChatbot}
            style={{
              width: '90px',
              height: '90px',
              borderRadius: '50%',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              transition: 'all 0.3s ease',
              backgroundColor: '#0072BB'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.1)'
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.2)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)'
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/Carpi_Icon.png`}
              alt="Carpi - Assistente Virtual"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '50%'
              }}
            />
          </div>
        </div>
      )}

      {/* Chatbot modal - responsivo */}
      {isOpen && (
        <div
          className="chatbot"
          style={{
            position: 'fixed',
            top: '0',
            right: '0',
            width: isMobile ? '100%' : '30%', // CORRIGIDO: 100% no mobile, 30% no desktop
            height: '100vh',
            backgroundColor: 'white',
            boxShadow: isMobile ? 'none' : '-4px 0 32px rgba(0,0,0,0.15)', // Remove sombra no mobile
            display: 'flex',
            flexDirection: 'column',
            zIndex: 9999, // Z-index muito alto para ficar acima de tudo
            overflow: 'hidden'
          }}
        >
          {/* Header */}
          <div
            style={{
              backgroundColor: '#0072BB',
              color: 'white',
              padding: isMobile ? '20px 16px' : '16px 20px', // Aumenta padding no mobile
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '1px solid rgba(255,255,255,0.1)'
            }}
          >
            <h3
              style={{
                margin: 0,
                fontSize: isMobile ? '1.2rem' : '1.1rem', // Aumenta fonte no mobile
                fontWeight: '600',
                fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
              }}
            >
              Fale com a Carpi
            </h3>
            <button
              onClick={() => setIsOpen(false)}
              style={{
                background: 'none',
                border: 'none',
                color: 'white',
                fontSize: isMobile ? '1.4rem' : '1.2rem', // Aumenta fonte no mobile
                cursor: 'pointer',
                padding: isMobile ? '12px' : '8px', // Aumenta padding no mobile
                borderRadius: '50%',
                width: isMobile ? '40px' : '32px', // Aumenta tamanho no mobile
                height: isMobile ? '40px' : '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'background-color 0.2s ease',
                minHeight: '44px', // Altura mínima para touch
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent'
              }}
            >
              ✕
            </button>
          </div>

          {/* Loading ou Iframe do Botpress */}
          <div
            style={{
              flex: 1,
              position: 'relative',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#f8f9fa'
            }}
          >
            {isLoading ? (
              // Loading spinner
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  border: '4px solid #e3e3e3',
                  borderTop: '4px solid #0072BB',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite'
                }} />
                <p style={{
                  color: '#666',
                  fontSize: '14px',
                  margin: 0,
                  fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                }}>
                  Carregando...
                </p>
              </div>
            ) : (
              // Iframe otimizado
              <iframe
                src="https://www.car.iat.pr.gov.br/botpress/lite/carpi/?m=channel-web&v=Fullscreen&options=%7B%22hideWidget%22%3Atrue%2C%22config%22%3A%7B%22enableReset%22%3Atrue%2C%22enableTranscriptDownload%22%3Atrue%7D%7D"
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  borderRadius: '0',
                  display: 'block'
                }}
                title="Chatbot Carpi"
                allow="microphone"
                loading="eager"
                onLoad={() => setIsLoading(false)}
              />
            )}
          </div>
        </div>
      )}

      {/* CSS responsivo adicional - apenas para o modal */}
      <style>{`
        @media (max-width: 768px) {
          .chatbot {
            width: 100% !important;
            box-shadow: none !important;
          }
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </>
  )
} 